import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=cdbaf38a&scoped=true"
import script from "./TicketDetail.vue?vue&type=script&lang=js"
export * from "./TicketDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketDetail.vue?vue&type=style&index=0&id=cdbaf38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbaf38a",
  null
  
)

export default component.exports